<ng-container *ngIf="notificationItem.type === 'Toast'">
    <div class="lv-notification-item" [ngClass]="'CardLayout' + notificationItem.category" >
        <div class="lv-notification-item-toast-header">
            <div>
                <mat-icon class="lv-notification-item-header-icon" [svgIcon]="notificationItem.icon"></mat-icon>
            </div>
            <div class="lv-notification-item-header-titel" [innerHTML]="notificationItem.titel"></div>
            <div class="lv-notification-item-header-close">
                <mat-icon [svgIcon]="'Times'" (click)="closeClicked()"></mat-icon>
            </div>
        </div>
        <div class="lv-notification-item-content" [innerHTML]="notificationItem.text"></div>
        <div class="lv-notification-item-action">
        </div>
    </div>
</ng-container>
<ng-container *ngIf="notificationItem.type === 'Alert' && notificationItem.closeIcon">
<div class="lv-notification-item" [ngClass]="'CardLayout' + notificationItem.category" >
  <div class="lv-notification-item-alert-header">
    <div>
      <mat-icon class="lv-notification-item-header-icon" [svgIcon]="notificationItem.icon"></mat-icon>
    </div>
    <div class="lv-notification-item-header-text" [innerHTML]="notificationItem.text"></div>
    <div class="lv-notification-item-header-close">
      <mat-icon [svgIcon]="'Times'" (click)="closeClicked()"></mat-icon>
    </div>
  </div>
</div>
</ng-container>
<ng-container *ngIf="notificationItem.type === 'Alert' && !notificationItem.closeIcon">
    <div class="lv-notification-item" [ngClass]="'CardLayout' + notificationItem.category" >
        <div class="lv-notification-item-alert-header noCloseIcon">
            <div>
                <mat-icon class="lv-notification-item-header-icon" [svgIcon]="notificationItem.icon"></mat-icon>
            </div>
            <div class="lv-notification-item-header-text noCloseIcon" [innerHTML]="notificationItem.text"></div>
        </div>
    </div>
</ng-container>
